import {
  SET_CURRENT_CATEGORY,
  SET_ACTIVE_CATEGORY,
  CLEAR_CATEGORIES_STATE
} from 'constants/reduceConstants';

const initialState = {
  currentCategory: {},
  activeCategory: {}
};

const categoryReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_CURRENT_CATEGORY:
      return { ...state, currentCategory: payload };
    case SET_ACTIVE_CATEGORY:
      return { ...state, activeCategory: { ...payload } };
    case CLEAR_CATEGORIES_STATE:
      return { ...initialState, searchValue: state.searchValue };
    default:
      return state;
  }
};

export default categoryReducer;
